import ErrorText from 'core/modules/atoms/ErrorText';
import { InputCheckbox, InputPassword } from 'ui';
import { PASSWORD_MIN_LENGTH } from 'core/utils/newPassword';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import FormField from 'ui/molecules/FormField/FormField';
import InputText from 'ui/atoms/InputText/InputText';

const AccountForm = ({ t, onBlurPassword, onChange, error = {}, onAcceptTerms, user }) => {
  return (
    <div className="account-form">
      <div className="account-form__field">
        <FormField error={!!error.name} errorMessage={error['name']} isRequired label={t('profile:Name')}>
          <InputText autoComplete="given-name" onChange={onChange} name="name" value={user.name || ''} />
        </FormField>
      </div>

      <div className="account-form__field">
        <FormField error={!!error.surname} errorMessage={error['surname']} isRequired label={t('profile:Surname')}>
          <InputText autoComplete="family-name" onChange={onChange} name="surname" value={user.surname || ''} />
        </FormField>
      </div>

      <div className="account-form__field">
        <FormField error={!!error.email} errorMessage={error['email']} isRequired label={t('profile:Email')}>
          <InputText
            disabled={user.identity_provider}
            autoComplete="email"
            iconLeft={true}
            onChange={onChange}
            name="email"
            icon="email"
            value={user.email || ''}
          />
        </FormField>
      </div>
      {!user.identity_provider && (
        <>
          <div className="account-form__field">
            <FormField error={!!error.confirmEmail} errorMessage={error['confirmEmail']} isRequired label={t('signup:Confirm Email')}>
              <InputText
                disabled={user.identity_provider}
                autoComplete="email"
                iconLeft={true}
                onChange={onChange}
                name="confirmEmail"
                icon="email"
                value={user.confirmEmail || ''}
              />
            </FormField>
          </div>
          <div className="account-form__field">
            <FormField
              error={!!error.password}
              errorMessage={error['password']}
              helperText={t('common:Must be at least X characters', { length: PASSWORD_MIN_LENGTH })}
              isRequired
              label={t('Password', { count: 3 })}
            >
              <InputPassword autoComplete="new-password" onBlur={onBlurPassword} onChange={onChange} name="password" value={user.password || ''} />
            </FormField>
          </div>
          <div className="account-form__field">
            <FormField error={!!error.confirmPassword} errorMessage={error['confirmPassword']} isRequired label={t('signup:Confirm password', { count: 3 })}>
              <InputPassword
                autoComplete="new-password"
                onBlur={onBlurPassword}
                onChange={onChange}
                name="confirmPassword"
                value={user.confirmPassword || ''}
              />
            </FormField>
          </div>
        </>
      )}
      <div className="account-form__field">
        <InputCheckbox
          name="accept"
          onChange={onAcceptTerms}
          checked={user.terms}
          label={
            <span>
              {t('signup:I’ve read and accept')}{' '}
              <a href="/terms" target="_blank" className="account-form__terms">
                {t('signup:terms and conditions')}
                <span className="sr-only"> ({t('messages:Opens in new window')})</span>
              </a>
            </span>
          }
        />
        {error.terms && <ErrorText text={error['terms']} />}
      </div>
    </div>
  );
};

AccountForm.propTypes = {
  t: PropTypes.func.isRequired,
  onBlurPassword: PropTypes.func,
  onChange: PropTypes.func,
  error: PropTypes.object,
  onAcceptTerms: PropTypes.func,
  user: PropTypes.shape({
    name: PropTypes.string,
    surname: PropTypes.string,
    identity_provider: PropTypes.string,
    email: PropTypes.string,
    confirmEmail: PropTypes.string,
    password: PropTypes.string,
    confirmPassword: PropTypes.string,
    terms: PropTypes.bool,
  }),
};

export default withTranslation(['profile', 'signup', 'placeholder'])(AccountForm);
